/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class GradeSchedulesRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      gradeSchedules: this.store.findAll('assessments/grade-schedule'),
      assessments: this.store.findAll('assessments/assessment'),
      modules: this.store.findAll('assessments/module'),
    });
  }

  /**
   * A hook you can use to reset controller values either when the model
   * changes or the route is exiting.
   *
   * ref: https://api.emberjs.com/ember/3.12/classes/Route/methods/resetController?anchor=resetController
   *
   * @param {Object} controller
   * @param {Boolean} isExiting
   * @param {Object} transition
   */
  resetController(controller) {
    controller.reset();
  }
}
